import styled from "styled-components"

export const NewsWrapper = styled.div`

.news {
    &_category {
        background-color: #fff;
        padding: 12px 12px 0 12px;
        list-style: none;
        margin: 22px 0 0 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 4px;
        &_item {
            a {
                height: 35px;
                display: flex;
                align-items: center;
                color: #fff;
                padding: 0 12px;
                margin-right: 12px;
                margin-bottom: 12px;
                text-align: center;
                &:hover {
                    background-color: #fd475a;
                    color: #fff;
                }
            }
        }
        .link_active{
            background-color: #fb6e2e;
        }
        .link_unactive{
            background-color: #469ef4;
        }
    }
    &_content {
        list-style: none;
        margin: 22px 0;
        padding: 0;
        background-color: #fff;
        &_item {
            &_link {
                display: flex;
                margin: 22px 0;
                height: 230px;
                &:hover .news_content_item_description_name{
                    color: #ff6801;
                }
                &:hover .news_content_item_thumbnail img{
                    transform: scale(1.04);
                }
            }
            &_thumbnail {
                width: 35%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width: 90%;
                    max-height: 90%;
                    object-fit: cover;
                    transition: all .3s linear;
                }
            }
            &_description {
                width: 65%;
                display: block;
                height: 100%;
                padding: 12px 12px 12px 0;
                &_name {
                    color: #1c1c1c;
                    font-size: 1.4rem;
                    font-weight: 500;
                    max-height: 55px;
                    overflow: hidden;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
                &_date{
                    padding: 0;
                    margin: 0 0 12px 0;
                    color: #626060;
                }
                &_post{
                    color: #1c1c1c;
                    margin: 0;
                    height: 90px;
                    overflow: hidden;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                }
            }
        }
        &_empty{
            height: 80vh;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            p{
                color: #ff6801;
                font-size: 1.2rem;
            }
        }
    }
    &_pagination{
        display: flex;
        justify-content: center;
    }
}

`
